<template>
  <div>
    <div class='container'>
      <div class='content-section'>
        <h3 style='text-align:center' class="title">
          <span style="white-space:nowrap">欢迎下载使用</span> <span style="white-space:nowrap">LogoUp 3D</span>
          <div><span style="white-space:nowrap">免费试用，</span> <span
              style="white-space:nowrap">也可通过软件帮助菜单购买续费功能微信购买专业版</span> </div>
        </h3>
        <div class='text' style='margin:1em 0;text-align:center;font-size:18px;'>
          <!-- 请将如下内容提交到公测申请邮箱<br></br>
          真实姓名 / 联系电话 / 工作单位
          <h4 class="apply-button" style='font-size:24px'>
            <a href='mailto:logoup-beta@hesion3d.com?subject=申请 LogoUp 3D 内测序列号&body=管理员您好！%0a我希望申请 LogoUp 3D 内测序列号。下面是我的真实信息以供校验。%0a%0a真实姓名: %0a联系电话: +86-%0a工作单位: %0a%0a新用户' target='_blank'
               style='border:solid 1px #b2d9e1;border-radius:8px;padding:0.5em 2em'><span class="apply-email">logoup-beta@hesion3d.com</span><span class="apply-email-alt">申请</span></a>
          </h4>
          经非机器人审核后，将由工程师通过邮箱回复您 Beta 公测序列号。<br></br> -->
          <a v-on:click='expandLinks' style='cursor:pointer'><b style='color:orange'>如果没能自动开始下载，请点击这里</b></a>
        </div>
        <transition name="slide-fade">
          <div class="row download-links mr-auto ml-auto" v-if='seen' style='margin-top:0;text-align:center;padding:0'>
            <div class="col-4">
              <a class='download' target='_blank'
                v-bind:href='getDownloadUrl($route.params.source == "email" ? "email" : "windows")'>
                <img src="/static/windows.png" />
                <div>{{ version }}</div>
                <span style="white-space:nowrap">Windows 7/8/10</span>
              </a>
            </div>
            <div class="col-4">
              <a class='download' target='_blank' v-bind:href='getDownloadUrl("linux")'>
                <img src="/static/ubuntu.png" />
                <div>{{ version }}</div>
                <span style="white-space:nowrap">Ubuntu 12.04+</span>
              </a>
            </div>
            <div class="col-4">
              <a class='download' target='_blank' v-bind:href='getDownloadUrl("linux")'>
                <img src="/static/ubuntu.png" />
                <div>{{ version }}</div>
                <span style="white-space:nowrap">Ubuntu 12.04+</span>
              </a>
            </div>



          </div>


        </transition>
        <img src='/static/developers.jpg' style='border-radius: 16px;width:100%;margin-top:3em' />
      </div>
      <div class='content-section' style='margin-top:2em'>&nbsp;<br />&nbsp;<br /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'download',
  data() {
    return {
      seen: false,
      version: '',
      downloadUrls: {},
    };
  },
  methods: {
    expandLinks() {
      this.seen = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 767px) {
  .apply-email {
    display: none;
  }

  .apply-email-alt {
    display: inline-block;
  }
}

@media (min-width: 100px) {
  .download {
    padding: 0.4rem 0.4rem;
    font-size: 0;
  }
}

@media (min-width: 768px) {
  .apply-email-alt {
    display: none;
  }

  .download {
    padding: 1rem 0.2rem;
    font-size: 0.5rem;
  }
}

@media (min-width: 992px) {
  .download {
    font-size: 0.6rem;
  }
}

.download {
  display: inline-block;
  background: white;
  text-shadow: none;
  box-shadow: 1px 1px 3px 3px #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.download img {
  width: 75%;
  margin-bottom: 5px
}

.download:hover {
  background: #f0f0f0;
}

.slide {
  background: #f0f0f0;
  padding: 2em 3em;
  margin-top: 2em;
  margin-bottom: 2em;
  line-height: 32px;
  border: solid 1px #ddd;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 100;
  margin-left: 120px;
}

.slide b {
  color: #0078d7;
}

.content-section .text {
  margin-left: 40px;
  color: #666;
  font-weight: 100;
  line-height: 1.7em;
}

.content-section ol {
  list-style: disc;
}

.content-section h3 {
  font-weight: 100;
  font-size: 48px;
  padding-left: 16px;
  padding-bottom: 1em;
  border-bottom: solid 12px #b2d9e1;
}

.content-section h3 div {
  font-size: 36px;
  color: #666;
}

.code-rect {
  border-radius: 16px;
  border: solid 1px #ccc;
}

.code {
  font-family: Courier;
  font-weight: bold;
}

.code .k {
  font-weight: bold;
  color: #00f;
}

.code .n {
  color: #c00;
}

.formula {
  vertical-align: middle;
  text-align: center;
}

.formula .item {
  display: inline-block;
  border-radius: 8px;
  border: solid 1px #ccc;
  padding: 0.8em;
  text-align: center;
  vertical-align: middle;
  background-color: #f84;
  color: white;
}

.formula .symbol {
  display: inline-block;
  vertical-align: middle;
  font-size: 36px;
  font-weight: 400;
}

.formula span {
  font-size: 14px;
}

table th {
  padding: 0.8em 1em;
  border-bottom: solid 1px #ccc;
  color: #f84;
  font-size: 18px;
  text-align: left;
}

table td {
  padding: 0.5em 1em;
  text-align: left;
  font-size: 14px;
}

h4.apply-button {
  margin: 1.33rem 0;
  font-size: 38px;
  color: #a19063;
  font-weight: 100;
}

h3.title {
  margin: 1em 0;
}

.download-links {
  max-width: 420px;
}
</style>


// WEBPACK FOOTER //
// src/components/download.vue